import { render, staticRenderFns } from "./Home.vue?vue&type=template&id=25bad7da&scoped=true"
import script from "./Home.js?vue&type=script&lang=js&external"
export * from "./Home.js?vue&type=script&lang=js&external"
import style0 from "./Home.scss?vue&type=style&index=0&id=25bad7da&prod&lang=scss&scoped=true&external"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "25bad7da",
  null
  
)

export default component.exports

/* nuxt-component-imports */
installComponents(component, {HotOrganicHeader: require('/home/runner/_work/app-hotmart-legal/app-hotmart-legal/components/Organisms/Organic/Header/Header.vue').default,HotMainHeader: require('/home/runner/_work/app-hotmart-legal/app-hotmart-legal/components/Organisms/MainHeader/MainHeader.vue').default,HotHeaderSidebar: require('/home/runner/_work/app-hotmart-legal/app-hotmart-legal/components/Organisms/HeaderSidebar/HeaderSidebar.vue').default,HotHero: require('/home/runner/_work/app-hotmart-legal/app-hotmart-legal/components/Organisms/Hero/Hero.vue').default,HotHomeNavigationCards: require('/home/runner/_work/app-hotmart-legal/app-hotmart-legal/components/Organisms/HomeNavigationCards/HomeNavigationCards.vue').default,HotFooter: require('/home/runner/_work/app-hotmart-legal/app-hotmart-legal/components/Organisms/Footer/Footer.vue').default})
